module.exports = __webpack_public_path__ + "static/media/vote.8dd58bf3.jpg";